module.exports = ".message {\r\n    margin-bottom: 20px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/change-password-dialog/change-password-dialog.component.css
// module id = 629
// module chunks = 1